export default __webpack_public_path__ + "static/media/zapsplat_leisure_playing_cards_flick_through_shuffle_007_62510.64404b62.mp3";